import { ShipmentPalletType } from "app/pages/shipments/types/domain";

/**
 * Pallet size string should be in format length_width
 */
export const mapPalletSizeStringToPalletType: Record<string, ShipmentPalletType | undefined> = {
  48_40: ShipmentPalletType.Pallet_48_40,
  42_42: ShipmentPalletType.Pallet_42_42,
  48_48: ShipmentPalletType.Pallet_48_48,
  40_48: ShipmentPalletType.Pallet_40_48,
  48_42: ShipmentPalletType.Pallet_48_42,
  40_40: ShipmentPalletType.Pallet_40_40,
  48_45: ShipmentPalletType.Pallet_48_45,
  44_44: ShipmentPalletType.Pallet_44_44,
  36_36: ShipmentPalletType.Pallet_36_36,
  48_36: ShipmentPalletType.Pallet_48_36,
  45_455: ShipmentPalletType.Pallet_45_455,
  48_20: ShipmentPalletType.Pallet_48_20,
};
